import { Dialog } from "@/Components";
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Inertia } from "@inertiajs/inertia";
import { showToast } from "@/Utilities/Utilities";
import { PropTypes } from "prop-types";
import axios from "axios";
import { LabeledInput } from "@/Components/Form";
import { usePage } from "@inertiajs/inertia-react";

const TwoFactorDialogCenter = ({
  showEnableModal,
  setShowEnableModal,
  setShowDisableModal,
  showDisableModal,
}) => {
  const { errors } = usePage().props;

  const [qrCode, setQrCode] = useState("");
  const [verifyCode, setVerifyCode] = useState("");

  const disableTwoFactor = () => {
    Inertia.delete(route("two-factor.destroy"), {
      onSuccess: () => {
        setShowDisableModal(false);
      },
    });
  };

  const verifyEnteredCode = () => {
    if (!verifyCode) {
      return showToast("Please enter the code from your 2FA app", "error");
    }

    const id = toast.loading("Please wait...");

    Inertia.post(
      route("two-factor.confirm"),
      { code: verifyCode },
      {
        onSuccess: () => {
          showToast(id, "Two factor authentication enabled", "success");
          setShowEnableModal(false);
        },
        onError: ({ code }) => {
          showToast(id, code, "error");
        },
      },
    );
  };

  useEffect(() => {
    if (showEnableModal) {
      axios.get("/user/two-factor-qr-code").then((response) => {
        setQrCode(response.data.svg);
      });
    }
  }, [showEnableModal]);

  return (
    <>
      {showEnableModal && (
        <Dialog
          openModal={showEnableModal}
          closeModal={() => setShowEnableModal(false)}
          modalStyle="popup"
          animation="fade-in"
          tagStyle="bg-primary text-white"
          tag="Configure two factor authentication"
          title={`You're about to enable two factor authentication`}
        >
          <p>
            Two-factor authentication adds an extra layer of security to your
            account. Once enabled, you'll need to provide a code from your phone
            in addition to your password.
          </p>

          {qrCode && (
            <div className="flex flex-col gap-2">
              <p>
                <span className="font-bold">Step 1</span>: Open your favorite
                2FA as such as Google Authenticator, Microsoft Authenticator
              </p>
              <p>
                <span className="font-bold">Step 2</span>: Choose "Scan a QR
                code" and scan the code below
              </p>
              <p>
                <span className="font-bold">Step 3</span>: Finally verify code
                shown in app
              </p>

              <div
                className="mt-4"
                dangerouslySetInnerHTML={{ __html: qrCode }}
              />

              <LabeledInput
                containerClass="mt-4"
                title="Verify code"
                placeholder="Enter code in 2FA app"
                name="code"
                value={verifyCode}
                onChange={(e) => setVerifyCode(e.target.value)}
                required
                error={errors.code}
              />
            </div>
          )}

          <div className="flex w-full items-center justify-end ">
            <a
              className="cursor-pointer py-2 text-blue underline"
              onClick={() => {
                disableTwoFactor();
                setShowEnableModal(false);
              }}
            >
              Never mind
            </a>
            <button
              className="btn-blue ml-3 grow-0 self-end"
              onClick={verifyEnteredCode}
              disabled={verifyCode === ""}
              type="button"
            >
              Confirm
            </button>
          </div>
        </Dialog>
      )}

      {showDisableModal && (
        <Dialog
          openModal={showDisableModal}
          closeModal={() => setShowDisableModal(false)}
          modalStyle="popup"
          animation="fade-in"
          tag="Disable two factor authentication"
          tagStyle="bg-[#FEE5E5]"
          title={`You're about to disable your two factor authentication`}
        >
          <p>
            Are you sure you want to disable two factor authentication? This
            will decrease the security of your account.
          </p>

          <div className="flex w-full items-center justify-end ">
            <a
              className="cursor-pointer py-2 text-blue underline"
              onClick={() => setShowDisableModal(false)}
            >
              Never mind
            </a>

            <button
              className="btn-blue ml-3 grow-0 self-end"
              onClick={disableTwoFactor}
              type="button"
            >
              Disable
            </button>
          </div>
        </Dialog>
      )}
    </>
  );
};

TwoFactorDialogCenter.propTypes = {
  showEnableModal: PropTypes.bool,
  setShowEnableModal: PropTypes.func,
  showDisableModal: PropTypes.bool,
  setShowDisableModal: PropTypes.func,
};

export default TwoFactorDialogCenter;
